"use client";
import { useEffect } from "react";

export default function CoreThemeToBody() {
  useEffect(() => {
    const themeElement = document.getElementById("informaCoreTheme");

    if (themeElement) {
      const coreTheme = themeElement.getAttribute("data-core-theme");

      if (coreTheme) {
        document.body.setAttribute("data-core-theme", coreTheme);
      }
    }
  }, []);

  return null;
}
